import { Directive, HostListener, inject } from '@angular/core';
import { NavigationService } from '@app/core/routing/navigation/navigation.service';

@Directive({
  selector: '[appBackButton]'
})
export class BackButtonDirective {
  private readonly navigation = inject(NavigationService);

  @HostListener('click')
  onClick(): void {
    this.navigation.back();
  }
}
